import { useQuery } from '@tanstack/react-query';

import { LiveNowPanel } from './LiveNowPanel';

import { catalogQueries } from '@/lib/queries/catalog';

/**
 * Left sidebar: the admin-managed CATEGORIES panel over the live panel. Reuses
 * the Increment 1 catalog stub directly (no duplicate seam). Per §1 the
 * categories panel collapses entirely when there are no visible categories —
 * against stubs that's the case, so only the live panel shows.
 */
export function CategorySidebar() {
  const { data: categories = [] } = useQuery(catalogQueries.visibleCategories());

  return (
    // id anchors are the targets of the footer's "Categories" / "Live now" links
    // (Spec 30 confirm 1 — no dedicated routes, they resolve to sections here).
    <aside id="categories" className="w-full shrink-0 space-y-8 md:w-56">
      {categories.length > 0 && (
        <nav>
          <p className="font-sans text-xs font-medium uppercase tracking-[0.12em] text-video-text-faint">
            Categories
          </p>
          <ul className="mt-3 space-y-1">
            {categories.map((c) => (
              <li key={c.id}>
                <a
                  href={`#category-${c.slug}`}
                  className="block rounded-sm px-2 py-1 font-sans text-sm text-video-text-muted hover:bg-video-panel hover:text-video-text"
                >
                  {c.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      )}
      <div id="live-now">
        <LiveNowPanel />
      </div>
    </aside>
  );
}
